// // import React, { useState } from 'react';
// // import captcha from './../../../assets/images/captcha.png';

// // function QueryForm() {
// //   const [formData, setFormData] = useState({
// //     firstName: '',
// //     surname: '',
// //     companyName: '',
// //     emailAddress: '',
// //     companyAddress: '',
// //     contactNumber: '',
// //     location: '',
// //     serviceCategory: '',
// //     message: '',
// //     uploadedFileName: '',
// //     uploadedContentType: '',
// //     uploadedFileBase64: ''
// //   });

// //   const [statusMessage, setStatusMessage] = useState('');
// //   const [isSubmitting, setIsSubmitting] = useState(false);

// //   const handleChange = (e) => {
// //     const { id, value } = e.target;
// //     setFormData({ ...formData, [id]: value });
// //   };

// //   const handleFileChange = async (e) => {
// //     const file = e.target.files[0];
// //     if (file) {
// //       const base64 = await toBase64(file);
// //       // Ensure only the Base64 string (no prefix) is sent
// //       const base64String = base64.includes(',') ? base64.split(',')[1] : base64;
// //       setFormData({
// //         ...formData,
// //         uploadedFileName: file.name,
// //         uploadedContentType: file.type,
// //         uploadedFileBase64: base64String
// //       });
// //     }
// //   };

// //   const toBase64 = (file) =>
// //     new Promise((resolve, reject) => {
// //       const reader = new FileReader();
// //       reader.readAsDataURL(file);
// //       reader.onload = () => resolve(reader.result);
// //       reader.onerror = (error) => reject(error);
// //     });

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     setStatusMessage('');
// //     setIsSubmitting(true);

// //     try {
// //       const response = await fetch('http://localhost:5287/api/QueryForm/submit', {
// //         method: 'POST',
// //         headers: { 'Content-Type': 'application/json' },
// //         body: JSON.stringify(formData)
// //       });

// //       const data = await response.json();
// //       if (response.ok) {
// //         setStatusMessage('Form submitted successfully!');
// //         setFormData({
// //           firstName: '',
// //           surname: '',
// //           companyName: '',
// //           emailAddress: '',
// //           companyAddress: '',
// //           contactNumber: '',
// //           location: '',
// //           serviceCategory: '',
// //           message: '',
// //           uploadedFileName: '',
// //           uploadedContentType: '',
// //           uploadedFileBase64: ''
// //         });
// //       } else {
// //         setStatusMessage(data.message || 'Submission failed.');
// //       }
// //     } catch (error) {
// //       console.error(error);
// //       setStatusMessage('Server error or network issue.');
// //     } finally {
// //       setIsSubmitting(false);
// //     }
// //   };

// //   return (
// //     <>
// //       <div className="service-title text-green-38B652 font-700 mb-3">QUERY FORMS</div>
// //       <div className="font-17 mb-4">
// //         Please submit your enquiry online which will send you an email with a unique reference number.
// //         Should your enquiry be of an urgent nature,
// //       </div>
// //       <div className="bg-gray-7d9199 p-4">
// //         <h2 className="font-27 font-700 text-white mb-4">QUERY FORMS</h2>

// //         {statusMessage && (
// //           <div className={`alert ${statusMessage.includes('success') ? 'alert-success' : 'alert-danger'}`}>
// //             {statusMessage}
// //           </div>
// //         )}

// //         <form className="row g-4 contact-form" onSubmit={handleSubmit}>
// //           <div className="col-sm-6 col-md-12 col-lg-6">
// //             <div className="row g-4">
// //               <div className="col-12">
// //                 <div className="position-relative">
// //                   <input
// //                     type="text"
// //                     className="form-control"
// //                     id="firstName"
// //                     value={formData.firstName}
// //                     onChange={handleChange}
// //                     required
// //                   />
// //                   <label htmlFor="FirstName">
// //                     <span className="text-orange-ef3e33">*</span>First Name
// //                   </label>
// //                 </div>
// //               </div>
// //               <div className="col-12">
// //                 <div className="position-relative">
// //                   <input
// //                     type="text"
// //                     className="form-control"
// //                     id="surname"
// //                     value={formData.surname}
// //                     onChange={handleChange}
// //                     required
// //                   />
// //                   <label htmlFor="surname">
// //                     <span className="text-orange-ef3e33">*</span>Surname
// //                   </label>
// //                 </div>
// //               </div>
// //               <div className="col-12">
// //                 <div className="position-relative">
// //                   <input
// //                     type="text"
// //                     className="form-control"
// //                     id="companyName"
// //                     value={formData.companyName}
// //                     onChange={handleChange}
// //                     required
// //                   />
// //                   <label htmlFor="CompanyName">
// //                     <span className="text-orange-ef3e33">*</span>Company Name
// //                   </label>
// //                 </div>
// //               </div>
// //               <div className="col-12">
// //                 <div className="position-relative">
// //                   <input
// //                     type="text"
// //                     className="form-control"
// //                     id="emailAddress"
// //                     value={formData.emailAddress}
// //                     onChange={handleChange}
// //                     required
// //                   />
// //                   <label htmlFor="EmailAddress">
// //                     <span className="text-orange-ef3e33">*</span>Email Address
// //                   </label>
// //                 </div>
// //               </div>
// //               <div className="col-12">
// //                 <div className="position-relative">
// //                   <input
// //                     type="text"
// //                     className="form-control"
// //                     id="companyAddress"
// //                     value={formData.companyAddress}
// //                     onChange={handleChange}
// //                     required
// //                   />
// //                   <label htmlFor="CompanyAddress">
// //                     <span className="text-orange-ef3e33">*</span>Company Address
// //                   </label>
// //                 </div>
// //               </div>
// //               <div className="col-12">
// //                 <div className="position-relative">
// //                   <input
// //                     type="text"
// //                     className="form-control"
// //                     id="contactNumber"
// //                     value={formData.contactNumber}
// //                     onChange={handleChange}
// //                     required
// //                   />
// //                   <label htmlFor="ContactNumber">
// //                     <span className="text-orange-ef3e33">*</span>Contact Number
// //                   </label>
// //                 </div>
// //               </div>
// //               <div className="col-12">
// //                 <div className="position-relative">
// //                   <select
// //                     className="form-select"
// //                     id="location"
// //                     value={formData.location}
// //                     onChange={handleChange}
// //                     required
// //                   >
// //                     <option value=""></option>
// //                     <option value="1">Eastern Cape</option>
// //                     <option value="2">Free State</option>
// //                     <option value="3">Gauteng</option>
// //                     <option value="4">Limpopo</option>
// //                     <option value="5">Mpumalanga</option>
// //                     <option value="6">Northern Cape</option>
// //                     <option value="7">North West</option>
// //                     <option value="8">Other</option>
// //                   </select>
// //                   <label htmlFor="location">
// //                     <span className="text-orange-ef3e33">*</span>Location
// //                   </label>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>

// //           <div className="col-sm-6 col-md-12 col-lg-6">
// //             <div className="row g-4">
// //               <div className="col-12">
// //                 <div className="position-relative">
// //                   <select
// //                     className="form-select"
// //                     id="serviceCategory"
// //                     value={formData.serviceCategory}
// //                     onChange={handleChange}
// //                     required
// //                   >
// //                     <option value="1">Skippers Certificates</option>
// //                     <option value="2">Seamans Record Books</option>
// //                     <option value="3">Verifications of Certificates</option>
// //                     <option value="4">STCW Certification</option>
// //                     <option value="5">Radio Certificates</option>
// //                     <option value="6">Small Vessel Safety and Licencing</option>
// //                     <option value="7">Cargoes (Bulk / Liquid / Gas)</option>
// //                     <option value="8">Boating</option>
// //                     <option value="9">Buoyancy</option>
// //                     <option value="10">Port State Control Inspections</option>
// //                     <option value="11">Naval Architecture</option>
// //                     <option value="12">Seafarer Welfare/Wages Complaints</option>
// //                     <option value="13">Supply Chain Management</option>
// //                     <option value="14">Fishing Vessel Safety and surveys</option>
// //                     <option value="15">Corporate Affairs &amp; Events</option>
// //                     <option value="16">Marine Notices</option>
// //                     <option value="17">Marine Casualties</option>
// //                     <option value="18">Flag State Inspections</option>
// //                     <option value="19">STCW CEC</option>
// //                     <option value="20">Radio Exams</option>
// //                     <option value="21">Marine Domain Awareness(MDA)</option>
// //                     <option value="22">IMDG</option>
// //                     <option value="23">Container VGM</option>
// //                     <option value="24">Other</option>
// //                   </select>
// //                   <label htmlFor="ServiceCategory">
// //                     <span className="text-orange-ef3e33">*</span>Service Category
// //                   </label>
// //                 </div>
// //               </div>

// //               <div className="col-12">
// //                 <div className="row g-4 align-items-center">
// //                   <div className="col-auto position-relative">
// //                     <input
// //                       type="file"
// //                       className="d-none"
// //                       id="fileUpload"
// //                       onChange={handleFileChange}
// //                     />
// //                     <label htmlFor="fileUpload" className="btn-green-38B652 height-45">
// //                       UPLOAD
// //                     </label>
// //                   </div>

// //                   <div className="col-md col-lg-12 col-xl position-relative">
// //                     <div className="bg-white height-45">
// //                       <div className="row align-items-center h-100">
// //                         <div className="col">
// //                           <div className="form-check ms-3 mb-0">
// //                             <input
// //                               className="form-check-input ratio-18"
// //                               type="checkbox"
// //                               id="checkDefault"
// //                             />
// //                             <label
// //                               className="form-check-label text-uppercase"
// //                               htmlFor="checkDefault"
// //                             >
// //                               i’m NOT A ROBOT
// //                             </label>
// //                           </div>
// //                         </div>
// //                         <div className="col-auto">
// //                           <img src={captcha} className="img-fluid mx-3" alt="" />
// //                         </div>
// //                       </div>
// //                     </div>
// //                   </div>
// //                 </div>

// //                 {/* Uploaded file name below the entire upload + captcha row */}
// //                 {formData.uploadedFileName && (
// //                   <div style={{ marginTop: '8px', fontSize: '0.9rem', color: '#000' }}>
// //                     {formData.uploadedFileName}
// //                   </div>
// //                 )}
// //               </div>

// //               <div className="col-12">
// //                 <div className="position-relative">
// //                   <textarea
// //                     className="form-control h-auto"
// //                     id="message"
// //                     rows="13"
// //                     value={formData.message}
// //                     onChange={handleChange}
// //                     required
// //                   ></textarea>
// //                   <label htmlFor="Description">
// //                     <span className="text-orange-ef3e33">*</span>Description
// //                   </label>
// //                 </div>
// //               </div>

// //               <div className="col-12">
// //                 <button className="btn-green-38B652 height-45" disabled={isSubmitting}>
// //                   {isSubmitting ? 'Submitting...' : 'SUBMIT'}
// //                 </button>
// //               </div>
// //             </div>
// //           </div>
// //         </form>
// //       </div>
// //     </>
// //   );
// // }

// // export default QueryForm;

// import React, { useState } from 'react';
// import captcha from './../../../assets/images/captcha.png';
// import { WebApiURL } from '../../../Constants/Constants';

// function QueryForm() {
//   const [formData, setFormData] = useState({
//     firstName: '',
//     surname: '',
//     companyName: '',
//     emailAddress: '',
//     companyAddress: '',
//     contactNumber: '',
//     location: '',
//     serviceCategory: '',
//     message: '',
//     uploadedFileName: '',
//     uploadedContentType: '',
//     uploadedFileBase64: ''
//   });

//   const [statusMessage, setStatusMessage] = useState('');
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const handleChange = (e) => {
//     const { id, value } = e.target;
//     setFormData({ ...formData, [id]: value });
//   };

//   const handleFileChange = async (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       try {
//         const base64 = await toBase64(file);
//         setFormData({
//           ...formData,
//           uploadedFileName: file.name,
//           uploadedContentType: file.type,
//           uploadedFileBase64: base64 // send full Data URI to backend
//         });
//       } catch (error) {
//         console.error("File conversion failed:", error);
//         setStatusMessage("Failed to read the file. Try again.");
//       }
//     }
//   };

//   const toBase64 = (file) =>
//     new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.readAsDataURL(file);
//       reader.onload = () => resolve(reader.result);
//       reader.onerror = (error) => reject(error);
//     });

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setStatusMessage('');
//     setIsSubmitting(true);

//     try {
//       const response = await fetch(`${WebApiURL}QueryForm/submit`, { // REAL API endpoint
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(formData)
//       });

//       // Parse JSON response
//       const data = await response.json();

//       if (response.ok) {
//         setStatusMessage(`Form submitted successfully! `);
//         // Reset form
//         setFormData({
//           firstName: '',
//           surname: '',
//           companyName: '',
//           emailAddress: '',
//           companyAddress: '',
//           contactNumber: '',
//           location: '',
//           serviceCategory: '',
//           message: '',
//           uploadedFileName: '',
//           uploadedContentType: '',
//           uploadedFileBase64: ''
//         });
//       } else {
//         setStatusMessage(data.message || 'Submission failed.');
//       }
//     } catch (error) {
//       console.error(error);
//       setStatusMessage('Server error or network issue.');
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <>
//       <div className="service-title text-green-38B652 font-700 mb-3">QUERY FORMS</div>
//       <div className="font-17 mb-4">
//         Please submit your enquiry online which will send you an email with a unique reference number.
//       </div>
//       <div className="bg-gray-7d9199 p-4">
//         <h2 className="font-27 font-700 text-white mb-4">QUERY FORMS</h2>

//         {statusMessage && (
//           <div className={`alert ${statusMessage.includes('successfully') ? 'alert-success' : 'alert-danger'}`}>
//             {statusMessage}
//           </div>
//         )}

//         <form className="row g-4 contact-form" onSubmit={handleSubmit}>
//           {/* Left column */}
//           <div className="col-sm-6 col-md-12 col-lg-6">
//             <div className="row g-4">
//               {['firstName', 'surname', 'companyName', 'emailAddress', 'companyAddress', 'contactNumber'].map(field => (
//                 <div className="col-12" key={field}>
//                   <div className="position-relative">
//                     <input
//                       type="text"
//                       className="form-control"
//                       id={field}
//                       value={formData[field]}
//                       onChange={handleChange}
//                       required
//                     />
//                     <label htmlFor={field}>
//                       <span className="text-orange-ef3e33">*</span> {field.replace(/([A-Z])/g, ' $1')}
//                     </label>
//                   </div>
//                 </div>
//               ))}

//               <div className="col-12">
//                 <div className="position-relative">
//                   <select
//                     className="form-select"
//                     id="location"
//                     value={formData.location}
//                     onChange={handleChange}
//                     required
//                   >
//                      <option value=""></option>
//                    <option value="1">Eastern Cape</option>
//                      <option value="2">Free State</option>
//                      <option value="3">Gauteng</option>
//                      <option value="4">Limpopo</option>
//                      <option value="5">Mpumalanga</option>
//                      <option value="6">Northern Cape</option>
//                      <option value="7">North West</option>
//                      <option value="8">Other</option>
//                   </select>
//                   <label htmlFor="location">
//                     <span className="text-orange-ef3e33">*</span> Location
//                   </label>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Right column */}
//           <div className="col-sm-6 col-md-12 col-lg-6">
//             <div className="row g-4">
//               <div className="col-12">
//                 <div className="position-relative">
//                   <select
//                     className="form-select"
//                     id="serviceCategory"
//                     value={formData.serviceCategory}
//                     onChange={handleChange}
//                     required
//                   >
//                     <option value="1">Skippers Certificates</option>
//                      <option value="2">Seamans Record Books</option>
//                      <option value="3">Verifications of Certificates</option>
//                      <option value="STCWCertification">STCW Certification</option>
//                      <option value="5">Radio Certificates</option>
//                      <option value="6">Small Vessel Safety and Licencing</option>
//                      <option value="7">Cargoes (Bulk / Liquid / Gas)</option>
//                      <option value="8">Boating</option>
//                      <option value="9">Buoyancy</option>
//                      <option value="10">Port State Control Inspections</option>
//                      <option value="11">Naval Architecture</option>
//                      <option value="12">Seafarer Welfare/Wages Complaints</option>
//                      <option value="13">Supply Chain Management</option>
//                      <option value="14">Fishing Vessel Safety and surveys</option>
//                      <option value="15">Corporate Affairs &amp; Events</option>
//                      <option value="16">Marine Notices</option>
//                      <option value="17">Marine Casualties</option>
//                      <option value="18">Flag State Inspections</option>
//                      <option value="19">STCW CEC</option>
//                      <option value="20">Radio Exams</option>
//                      <option value="21">Marine Domain Awareness(MDA)</option>
//                      <option value="22">IMDG</option>
//                     <option value="23">Container VGM</option>
//                     <option value="24">Other</option>
//                   </select>
//                   <label htmlFor="serviceCategory">
//                     <span className="text-orange-ef3e33">*</span> Service Category
//                   </label>
//                 </div>
//               </div>

//               <div className="col-12">
//                 <div className="row g-4 align-items-center">
//                   <div className="col-auto position-relative">
//                     <input
//                       type="file"
//                       className="d-none"
//                       id="fileUpload"
//                       onChange={handleFileChange}
//                       accept=".pdf,.doc,.docx,.png,.jpg"
//                       required
//                     />
//                     <label htmlFor="fileUpload" className="btn-green-38B652 height-45">
//                       <span className="text-orange-ef3e33">*</span>UPLOAD
//                     </label>
//                   </div>
//                   <div className="col-md col-lg-12 col-xl position-relative">
//                     <div className="bg-white height-45">
//                       <div className="row align-items-center h-100">
//                         <div className="col">
//                           <div className="form-check ms-3 mb-0">
//                             <input className="form-check-input ratio-18" type="checkbox" id="checkDefault" />
//                             <label className="form-check-label text-uppercase" htmlFor="checkDefault">
//                               i’m NOT A ROBOT
//                             </label>
//                           </div>
//                         </div>
//                         <div className="col-auto">
//                           <img src={captcha} className="img-fluid mx-3" alt="captcha" />
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 {formData.uploadedFileName && (
//                   <div style={{ marginTop: '8px', fontSize: '0.9rem', color: '#000' }}>
//                     {formData.uploadedFileName}
//                   </div>
//                 )}
//               </div>

//               <div className="col-12">
//                 <div className="position-relative">
//                   <textarea
//                     className="form-control h-auto"
//                     id="message"
//                     rows="13"
//                     value={formData.message}
//                     onChange={handleChange}
//                     required
//                   ></textarea>
//                   <label htmlFor="message">
//                     <span className="text-orange-ef3e33">*</span> Description
//                   </label>
//                 </div>
//               </div>

//               <div className="col-12">
//                 <button className="btn-green-38B652 height-45" disabled={isSubmitting}>
//                   {isSubmitting ? 'Submitting...' : 'SUBMIT'}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </form>
//       </div>
//     </>
//   );
// }

// export default QueryForm;

// import React, { useState } from 'react';
// import captcha from './../../../assets/images/captcha.png';
// import { WebApiURL } from '../../../Constants/Constants';

// function QueryForm() {
//   const [formData, setFormData] = useState({
//     firstName: '',
//     surname: '',
//     companyName: '',
//     emailAddress: '',
//     companyAddress: '',
//     contactNumber: '',
//     location: '',
//     serviceCategory: '',
//     message: '',
//     uploadedFileName: '',
//     uploadedContentType: '',
//     uploadedFileBase64: ''
//   });

//   const [statusMessage, setStatusMessage] = useState('');
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const handleChange = (e) => {
//     const { id, value } = e.target;
//     setFormData({ ...formData, [id]: value });
//   };

//   const handleFileChange = async (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       try {
//         const base64 = await toBase64(file);
//         setFormData({
//           ...formData,
//           uploadedFileName: file.name,
//           uploadedContentType: file.type,
//           uploadedFileBase64: base64 // send full Data URI to backend
//         });
//       } catch (error) {
//         console.error("File conversion failed:", error);
//         setStatusMessage("Failed to read the file. Try again.");
//       }
//     }
//   };

//   const toBase64 = (file) =>
//     new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.readAsDataURL(file);
//       reader.onload = () => resolve(reader.result);
//       reader.onerror = (error) => reject(error);
//     });

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setStatusMessage('');
//     setIsSubmitting(true);

//     try {
//       const response = await fetch(`${WebApiURL}QueryForm/submit`, { // REAL API endpoint
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(formData)
//       });

//       // Parse JSON response
//       const data = await response.json();

//       if (response.ok) {
//         setStatusMessage(`Form submitted successfully! `);
//         // Reset form
//         setFormData({
//           firstName: '',
//           surname: '',
//           companyName: '',
//           emailAddress: '',
//           companyAddress: '',
//           contactNumber: '',
//           location: '',
//           serviceCategory: '',
//           message: '',
//           uploadedFileName: '',
//           uploadedContentType: '',
//           uploadedFileBase64: ''
//         });
//       } else {
//         setStatusMessage(data.message || 'Submission failed.');
//       }
//     } catch (error) {
//       console.error(error);
//       setStatusMessage('Server error or network issue.');
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <>
//       <div className="service-title text-green-38B652 font-700 mb-3">QUERY FORMS</div>
//       <div className="font-17 mb-4">
//         Please submit your enquiry online which will send you an email with a unique reference number.
//       </div>
//       <div className="bg-gray-7d9199 p-4">
//         <h2 className="font-27 font-700 text-white mb-4">QUERY FORMS</h2>

//         {statusMessage && (
//           <div className={`alert ${statusMessage.includes('successfully') ? 'alert-success' : 'alert-danger'}`}>
//             {statusMessage}
//           </div>
//         )}

//         <form className="row g-4 contact-form" onSubmit={handleSubmit}>
//           {/* Left column */}
//           <div className="col-sm-6 col-md-12 col-lg-6">
//             <div className="row g-4">
//               {['firstName', 'surname', 'companyName', 'emailAddress', 'companyAddress', 'contactNumber'].map(field => (
//                 <div className="col-12" key={field}>
//                   <div className="position-relative">
//                     <input
//                       type="text"
//                       className="form-control"
//                       id={field}
//                       value={formData[field]}
//                       onChange={handleChange}
//                       required
//                     />
//                     <label htmlFor={field}>
//                       <span className="text-orange-ef3e33">*</span> {field.replace(/([A-Z])/g, ' $1')}
//                     </label>
//                   </div>
//                 </div>
//               ))}

//               <div className="col-12">
//                 <div className="position-relative">
//                   <select
//                     className="form-select"
//                     id="location"
//                     value={formData.location}
//                     onChange={handleChange}
//                     required
//                   >
//                      <option value=""></option>
//                    <option value="1">Eastern Cape</option>
//                      <option value="2">Free State</option>
//                      <option value="3">Gauteng</option>
//                      <option value="4">Limpopo</option>
//                      <option value="5">Mpumalanga</option>
//                      <option value="6">Northern Cape</option>
//                      <option value="7">North West</option>
//                      <option value="8">Other</option>
//                   </select>
//                   <label htmlFor="location">
//                     <span className="text-orange-ef3e33">*</span> Location
//                   </label>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Right column */}
//           <div className="col-sm-6 col-md-12 col-lg-6">
//             <div className="row g-4">
//               <div className="col-12">
//                 <div className="position-relative">
//                   <select
//                     className="form-select"
//                     id="serviceCategory"
//                     value={formData.serviceCategory}
//                     onChange={handleChange}
//                     required
//                   >
//                     <option value="1">Skippers Certificates</option>
//                      <option value="2">Seamans Record Books</option>
//                      <option value="3">Verifications of Certificates</option>
//                      <option value="STCWCertification">STCW Certification</option>
//                      <option value="5">Radio Certificates</option>
//                      <option value="6">Small Vessel Safety and Licencing</option>
//                      <option value="7">Cargoes (Bulk / Liquid / Gas)</option>
//                      <option value="8">Boating</option>
//                      <option value="9">Buoyancy</option>
//                      <option value="10">Port State Control Inspections</option>
//                      <option value="11">Naval Architecture</option>
//                      <option value="12">Seafarer Welfare/Wages Complaints</option>
//                      <option value="13">Supply Chain Management</option>
//                      <option value="14">Fishing Vessel Safety and surveys</option>
//                      <option value="15">Corporate Affairs &amp; Events</option>
//                      <option value="16">Marine Notices</option>
//                      <option value="17">Marine Casualties</option>
//                      <option value="18">Flag State Inspections</option>
//                      <option value="19">STCW CEC</option>
//                      <option value="20">Radio Exams</option>
//                      <option value="21">Marine Domain Awareness(MDA)</option>
//                      <option value="22">IMDG</option>
//                     <option value="23">Container VGM</option>
//                     <option value="24">Other</option>
//                   </select>
//                   <label htmlFor="serviceCategory">
//                     <span className="text-orange-ef3e33">*</span> Service Category
//                   </label>
//                 </div>
//               </div>

//               <div className="col-12">
//                 <div className="row g-4 align-items-center">
//                   <div className="col-auto position-relative">
//                     <input
//                       type="file"
//                       className="d-none"
//                       id="fileUpload"
//                       onChange={handleFileChange}
//                       accept=".pdf,.doc,.docx,.png,.jpg"
                      
//                     />
//                     <label htmlFor="fileUpload" className="btn-green-38B652 height-45">
//                       <span className="text-orange-ef3e33"></span>UPLOAD
//                     </label>
//                   </div>
//                   <div className="col-md col-lg-12 col-xl position-relative">
//                     <div className="bg-white height-45">
//                       <div className="row align-items-center h-100">
//                         <div className="col">
//                           <div className="form-check ms-3 mb-0">
//                             <input className="form-check-input ratio-18" type="checkbox" id="checkDefault" />
//                             <label className="form-check-label text-uppercase" htmlFor="checkDefault">
//                               i’m NOT A ROBOT
//                             </label>
//                           </div>
//                         </div>
//                         <div className="col-auto">
//                           <img src={captcha} className="img-fluid mx-3" alt="captcha" />
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 {formData.uploadedFileName && (
//                   <div style={{ marginTop: '8px', fontSize: '0.9rem', color: '#000' }}>
//                     {formData.uploadedFileName}
//                   </div>
//                 )}
//               </div>

//               <div className="col-12">
//                 <div className="position-relative">
//                   <textarea
//                     className="form-control h-auto"
//                     id="message"
//                     rows="13"
//                     value={formData.message}
//                     onChange={handleChange}
//                     required
//                   ></textarea>
//                   <label htmlFor="message">
//                     <span className="text-orange-ef3e33">*</span> Description
//                   </label>
//                 </div>
//               </div>

//               <div className="col-12">
//                 <button className="btn-green-38B652 height-45" disabled={isSubmitting}>
//                   {isSubmitting ? 'Submitting...' : 'SUBMIT'}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </form>
//       </div>
//     </>
//   );
// }

// export default QueryForm;


import React, { useState } from 'react';
import captcha from './../../../assets/images/captcha.png';
import { WebApiURL } from '../../../Constants/Constants';

function QueryForm() {
  const [formData, setFormData] = useState({
    firstName: '',
    surname: '',
    companyName: '',
    emailAddress: '',
    companyAddress: '',
    contactNumber: '',
    location: '',
    serviceCategory: '',
    message: '',
    uploadedFileName: '',
    uploadedContentType: '',
    uploadedFileBase64: ''
  });

  const [statusMessage, setStatusMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      try {
        const base64 = await toBase64(file);
        setFormData({
          ...formData,
          uploadedFileName: file.name,
          uploadedContentType: file.type,
          uploadedFileBase64: base64 // send full Data URI to backend
        });
      } catch (error) {
        console.error("File conversion failed:", error);
        setStatusMessage("Failed to read the file. Try again.");
      }
    }
  };

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatusMessage('');
    setIsSubmitting(true);

    try {
      const response = await fetch(`${WebApiURL}QueryForm/submit`, { // REAL API endpoint
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      // Parse JSON response
      const data = await response.json();

      if (response.ok) {
        setStatusMessage(`Form submitted successfully! `);
        // Reset form
        setFormData({
          firstName: '',
          surname: '',
          companyName: '',
          emailAddress: '',
          companyAddress: '',
          contactNumber: '',
          location: '',
          serviceCategory: '',
          message: '',
          uploadedFileName: '',
          uploadedContentType: '',
          uploadedFileBase64: ''
        });
      } else {
        setStatusMessage(data.message || 'Submission failed.');
      }
    } catch (error) {
      console.error(error);
      setStatusMessage('Server error or network issue.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="service-title text-green-38B652 font-700 mb-3">QUERY FORMS </div>
      <div className="font-17 mb-4">
        Please submit your enquiry online which will send you an email with a unique reference number.
      </div>
      <div className="bg-gray-7d9199 p-4">
        <h2 className="font-27 font-700 text-white mb-4">QUERY FORMS</h2>

        {statusMessage && (
          <div className={`alert ${statusMessage.includes('successfully') ? 'alert-success' : 'alert-danger'}`}>
            {statusMessage}
          </div>
        )}

        <form className="row g-4 contact-form" onSubmit={handleSubmit}>
          {/* Left column */}
          <div className="col-sm-6 col-md-12 col-lg-6">
            <div className="row g-4">
              {['firstName', 'surname', 'companyName', 'emailAddress', 'companyAddress', 'contactNumber'].map(field => (
                <div className="col-12" key={field}>
                  <div className="position-relative">
                    <input
                      type="text"
                      className="form-control"
                      id={field}
                      value={formData[field]}
                      onChange={handleChange}
                      required
                    />
                    <label htmlFor={field}>
                      <span className="text-orange-ef3e33">*</span> {field.replace(/([A-Z])/g, ' $1')}
                    </label>
                  </div>
                </div>
              ))}

              <div className="col-12">
                <div className="position-relative">
                  <select
                    className="form-select"
                    id="location"
                    value={formData.location}
                    onChange={handleChange}
                    required
                  >

                    <option value=""></option>
                    <option value="Eastern Cape">Eastern Cape</option>
                    <option value="Free State">Free State</option>
                    <option value="Gauteng">Gauteng</option>
                    <option value="Limpopo">Limpopo</option>
                    <option value="Mpumalanga">Mpumalanga</option>
                    <option value="Northern Cape">Northern Cape</option>
                    <option value="North West">North West</option>
                    <option value="Other">Other</option>
                  </select>
                  <label htmlFor="location">
                    <span className="text-orange-ef3e33">*</span> Location
                  </label>
                </div>
              </div>
            </div>
          </div>

          {/* Right column */}
          <div className="col-sm-6 col-md-12 col-lg-6">
            <div className="row g-4">
              <div className="col-12">
                <div className="position-relative">
                  <select
                    className="form-select"
                    id="serviceCategory"
                    value={formData.serviceCategory}
                    onChange={handleChange}
                    required
                  >
                    <option value="Skippers Certificates">Skippers Certificates</option>
                    <option value="Seamans Record Books">Seamans Record Books</option>
                    <option value="Verifications of Certificates">Verifications of Certificates</option>
                    <option value="STCW Certification">STCW Certification</option>
                    <option value="Radio Certificates">Radio Certificates</option>
                    <option value="Small Vessel Safety and Licencing">Small Vessel Safety and Licencing</option>
                    <option value="Cargoes (Bulk / Liquid / Gas)">Cargoes (Bulk / Liquid / Gas)</option>
                    <option value="Boating">Boating</option>
                    <option value="Buoyancy">Buoyancy</option>
                    <option value="Port State Control Inspections">Port State Control Inspections</option>
                    <option value="Naval Architecture">Naval Architecture</option>
                    <option value="Seafarer Welfare/Wages Complaints">Seafarer Welfare/Wages Complaints</option>
                    <option value="Supply Chain Management">Supply Chain Management</option>
                    <option value="Fishing Vessel Safety and surveys">Fishing Vessel Safety and surveys</option>
                    <option value="Corporate Affairs & Events">Corporate Affairs & Events</option>
                    <option value="Marine Notices">Marine Notices</option>
                    <option value="Marine Casualties">Marine Casualties</option>
                    <option value="Flag State Inspections">Flag State Inspections</option>
                    <option value="STCW CEC">STCW CEC</option>
                    <option value="Radio Exams">Radio Exams</option>
                    <option value="Marine Domain Awareness(MDA)">Marine Domain Awareness(MDA)</option>
                    <option value="IMDG">IMDG</option>
                    <option value="Container VGM">Container VGM</option>
                    <option value="Other">Other</option>

                  </select>
                  <label htmlFor="serviceCategory">
                    <span className="text-orange-ef3e33">*</span> Service Category
                  </label>
                </div>
              </div>

              <div className="col-12">
                <div className="row g-4 align-items-center">
                  <div className="col-auto position-relative">
                    <input
                      type="file"
                      className="d-none"
                      id="fileUpload"
                      onChange={handleFileChange}
                      accept=".pdf,.doc,.docx,.png,.jpg"

                    />
                    <label htmlFor="fileUpload" className="btn-green-38B652 height-45">
                      <span className="text-orange-ef3e33"></span>UPLOAD
                    </label>
                  </div>
                  <div className="col-md col-lg-12 col-xl position-relative">
                    <div className="bg-white height-45">
                      <div className="row align-items-center h-100">
                        <div className="col">
                          <div className="form-check ms-3 mb-0">
                            <input className="form-check-input ratio-18" type="checkbox" id="checkDefault" />
                            <label className="form-check-label text-uppercase" htmlFor="checkDefault">
                              i’m NOT A ROBOT
                            </label>
                          </div>
                        </div>
                        <div className="col-auto">
                          <img src={captcha} className="img-fluid mx-3" alt="captcha" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {formData.uploadedFileName && (
                  <div style={{ marginTop: '8px', fontSize: '0.9rem', color: '#000' }}>
                    {formData.uploadedFileName}
                  </div>
                )}
              </div>

              <div className="col-12">
                <div className="position-relative">
                  <textarea
                    className="form-control h-auto"
                    id="message"
                    rows="13"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                  <label htmlFor="message">
                    <span className="text-orange-ef3e33">*</span> Description
                  </label>
                </div>
              </div>

              <div className="col-12">
                <button className="btn-green-38B652 height-45" disabled={isSubmitting}>
                  {isSubmitting ? 'Submitting...' : 'SUBMIT'}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default QueryForm;